import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import Features from "../../components/features";
import Intents from "../../components/intents";
import Qualifiers from "../../components/qualifiers";
import Questions from "../../components/questions";
import { enableDynamicFeedback } from "../../utils/config";

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Settings = () => {
  const [value, setValue] = React.useState(0);
  const userEnabledFeatures = localStorage.getItem("userenabledFeatures");
  const isDynamicFeedbackEnabled = userEnabledFeatures
    ? JSON.parse(userEnabledFeatures).enableDynamicFeedback
    : false;

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="settings-wrap">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="user tab">
          <Tab label="Features" {...a11yProps(0)} />
          {enableDynamicFeedback && isDynamicFeedbackEnabled && (
            <Tab label="Intents" {...a11yProps(1)} />
          )}
          {enableDynamicFeedback && isDynamicFeedbackEnabled && (
            <Tab label="Qualifiers" {...a11yProps(2)} />
          )}
          {enableDynamicFeedback && isDynamicFeedbackEnabled && (
            <Tab label="Questions" {...a11yProps(2)} />
          )}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <Features />
      </TabPanel>
      {enableDynamicFeedback && isDynamicFeedbackEnabled && (
        <TabPanel value={value} index={1}>
          <Intents />
        </TabPanel>
      )}
      {enableDynamicFeedback && isDynamicFeedbackEnabled && (
        <TabPanel value={value} index={2}>
          <Qualifiers />
        </TabPanel>
      )}
      {enableDynamicFeedback && isDynamicFeedbackEnabled && (
        <TabPanel value={value} index={3}>
          <Questions />
        </TabPanel>
      )}
    </div>
  );
};

export default Settings;
